import { Button, styled } from '@clickcease/cc-client-components-lib'

export const TableStyles = {
  width: '100%',
  backgroundColor: '$white',
  marginTop: '20px',
  boxShadow: '0 2px 4px 0 #0000000d',
  borderTopLeftRadius: '.8em',
  borderTopRightRadius: '.8em',
  '& > thead > th': {
    borderBottom: '1px solid rgb(245, 245, 245)',
  },
}

export const WrapperStyles = {
  minHeight: '100px',
}

export const StyledTh = styled('th', {
  fontWeight: '$sb',
  borderBottom: 'none !important',
  padding: '20px 0px !important',
  variants: {
    centered: {
      true: {
        textAlign: 'center',
      },
    },
  },
})

export const StyledTr = styled('tr', {
  height: '64px',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#FFF5F9',
  },
})

export const StyledTd = styled('td', {
  width: '280px',
  color: '$mainTextColor',
  borderTop: '1px solid rgb(245, 245, 245) !important',
  borderBottom: '1px solid rgb(245, 245, 245) !important',
  fontWeight: '$l',
  fontSize: '16px',
  variants: {
    centered: {
      true: {
        fontSize: '14px',
      },
    },
    end: {
      true: {
        width: '150px',
      },
    },
  },
})

export const StatusWrapper = styled('div', {
  display: 'flex',
  gap: '10px',
  alignItems: 'inherit',
  justifyContent: 'flex-end',
})

export const GetProtectedButton = styled(Button, {
  fontWeight: '400',
  cursor: 'pointer',
  backgroundColor: '$lightOrange !important',
  '& label': {
    cursor: 'pointer',
  },
  ['&:hover']: {
    backgroundColor: '$buttonHovered !important',
    color: '$lightOrange !important',
    textDecoration: 'none !important',
  },
})

export const TooltipWrapper = styled('div', {
  display: 'flex',
  gap: '10px',
})
